import { I_GENERIC_ITEMS } from "@/src-refactor/modules/shared/model/interface/items.interface";
import MxFormErrorMessage from "@rf-l2/form/MxFormErrorMessage";
import MxFormFieldController from "@rf-l2/form/MxFormFieldController";
import MxFormSelectOwnerField, {
  IMxFormSelectOwnerFieldProps
} from "@rf-l2/form/select/MxFormSelectOwnerField";

interface MxFormL3AutoCompleteProps extends IMxFormSelectOwnerFieldProps {
  name: string;
  withreacthookform?: 1 | 0;
}
function MxFormL3SelectOwnerField(props: MxFormL3AutoCompleteProps) {
  return (
    <MxFormFieldController
      name={props.name}
      withreacthookform={props.withreacthookform}
    >
      <MxFormSelectOwnerField {...props} />
      <MxFormErrorMessage />
    </MxFormFieldController>
  );
}

export default MxFormL3SelectOwnerField;
